import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import type { ClientPermissionSet } from "../../store/state/user/types";
import ClientSelectionCard from "./ClientSelectionCard";

interface Props {
  permissions: ClientPermissionSet[];
}

const ClientSelectionList = ({ permissions }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Stack spacing={2.5} sx={{ alignItems: "center" }}>
      <Typography color="textSecondary">
        In the meantime, you can navigate to other portals you have access to within Entrilia.
      </Typography>
      <Stack spacing={1} sx={{ width: isMobile ? "calc(100% - 32px)" : "25rem" }}>
        {permissions.map((clientPermissions) => (
          <ClientSelectionCard key={clientPermissions.clientCode} clientPermissions={clientPermissions} />
        ))}
      </Stack>
    </Stack>
  );
};

export default ClientSelectionList;
